<template>
  <a
    class="navbar-brand"
    style="cursor: pointer"
    @click="() => this.$router.push({ path: 'dashboard-default' })"
  >
    <img
      src="@/assets/img/logos/r-logo.svg"
      class="d-inline-block align-top img-responsive"
      width="150"
      :style="brandStyles"
    />
  </a>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "navbar-navbar-brand",
  computed: {
    ...mapGetters(["getDarkMode"]),
    brandStyles() {
      return {
        filter: this.getDarkMode ? "brightness(2)" : "",
      };
    },
  },
};
</script>
